import {BaseApiTemplateService, Core2Config} from '../../shared';
import {WfProjectCategoryContainerModel} from '../../../../../../models/aggregates/wf/project/wf-project-category-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class WfProjectCategoryService extends BaseApiTemplateService<WfProjectCategoryContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-categories';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-categories';
    this.httpClient = http;
  }
}
